var _path, _g, _rect, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDocFill = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 36,
    viewBox: "0 0 30 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "maskId",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.6574C0 10.1206 0.215783 9.60632 0.59882 9.23025L9.41652 0.572872C9.79048 0.205708 10.2936 0 10.8177 0H28C29.1046 0 30 0.895431 30 2V26C30 31.5228 25.5228 36 20 36H2C0.89543 36 0 35.1046 0 34V10.6574Z",
    fill: "#B3B2C2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#maskId)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10.6574C0 10.1206 0.215783 9.60632 0.59882 9.23025L9.41652 0.572872C9.79048 0.205708 10.2936 0 10.8177 0H28C29.1046 0 30 0.895431 30 2V28C30 32.4183 26.4183 36 22 36H2C0.89543 36 0 35.1046 0 34V10.6574Z",
    fill: "url(#gradientId1)"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    width: 11,
    height: 11,
    fill: "url(#gradientId2)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    x: 6,
    y: 17,
    width: 18,
    height: 3,
    rx: 1,
    fill: "#E5E4EC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    x: 6,
    y: 22,
    width: 18,
    height: 3,
    rx: 1,
    fill: "#E5E4EC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradientId1",
    x1: 4.44444,
    y1: 5.625,
    x2: 34.2546,
    y2: 35.0672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#928BB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E4EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradientId2",
    x1: 11,
    y1: 11,
    x2: 5,
    y2: 5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.807045,
    stopColor: "#E5E4EC",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E4EC",
    stopOpacity: 0.6
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDocFill);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/docFill.0f9f4c2d04fe0753884b620b21b25450.svg";